<template>
    <div class="py-12 sm:px-8 px-2 bg-soft">
        <div class="flex items-center justify-center gap-2 flex-wrap">
            <div class="xs:p-5 p-3 flex flex-col items-center justify-center mb-6 rounded-md hover:bg-gray-200 cursor-pointer" v-for="business in type_icons">
                <component v-bind:is="business.icon" size="32" stroke-width="1.5" class="text-success mb-4"></component>
                <p class="font-medium ">{{ business.name }}</p>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { PlaneInflightIcon, IdIcon, CameraIcon, BuildingBridgeIcon, CalendarIcon, MusicIcon, HammerIcon, HeartIcon, BrandHipchatIcon, BulbIcon, BuildingEstateIcon, BeerIcon, ShoppingCartIcon, DeviceLaptopIcon, PlanetIcon, BuildingSkyscraperIcon, BuildingBankIcon, SchoolIcon, AssemblyIcon, MedicalCrossIcon } from "vue-tabler-icons";
export default defineComponent({
    setup() {

    },
    props: {
        type_icons: {
            default: [],
            type: Array<{
                icon?: string,
                name: string
            }>
        }
    },
    components: { PlaneInflightIcon, IdIcon, CameraIcon, BuildingBridgeIcon, CalendarIcon, MusicIcon, HammerIcon, HeartIcon, BrandHipchatIcon, BulbIcon, BuildingEstateIcon, BeerIcon, ShoppingCartIcon, DeviceLaptopIcon, PlanetIcon, BuildingSkyscraperIcon, BuildingBankIcon, SchoolIcon, AssemblyIcon, MedicalCrossIcon }
})

</script>